import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {Observable, of} from 'rxjs';
import {Invoice} from '../../../bills/shared/model/invoice.model';
import {FacadeService} from '../../service/facade/facade.service';
import {catchError, map} from 'rxjs/operators';

@Injectable()
export class InvoiceResolver implements Resolve<Observable<Invoice>> {
  constructor(private facadeService: FacadeService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<Invoice> {
    const invoiceId = route.queryParams['i'];
    return this.facadeService.getInvoiceById(invoiceId).pipe(
      map((data) => data),
      catchError(error => {
        return of({error: error});
      })
    );
  }
}
